module.exports = __webpack_public_path__ + "assets/5809228a2849449b50ef33f6c5b73db2.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/buttons/coins/bet-2.mp3
 ** module id = 221
 ** module chunks = 0
 **/